module.exports = "https://99designs-start-assets.imgix.net/js/d3121ff8c3995448ef2c3de54e26a326.svg";